import {
	switchSiteAPI,
	getResultListAPI,
	addSiteAPI,
	confirmSiteAPI,
} from '@/api/website-configure'
import storage from '../../utils/storage'

const websiteConfigure = {
	namespaced: true,
	state: () => ({
		// 搜索结果数据
		resultList: {
			list: [],
			total: 0,
		},
		currentSite: {
			data: {
				site_id: null,
				api_key: null,
				platform: null
			}
		},
		currentSiteInfo: storage.getItem('current_site_Info','sessionStorage') || {},
	}),
	mutations: {
		/* 设置搜索结果数据 */
		setResultList(state,result) {
			state.resultList = { ...result }
		},
		setCurrentSite(state,result) {
			state.currentSite = { ...result }
			// storage.setItem('site_id',result?.data?.site_id || null,'sessionStorage')
			// storage.setItem('api_key',result?.data?.api_key || null,'sessionStorage')
			// storage.setItem('platform',result?.data?.platform || null,'sessionStorage')
		},
		setCurrentSiteInfo(state,data) {
			state.currentSiteInfo = { ...data }
			storage.setItem('current_site_Info',{ ...data },'sessionStorage')
		},
	},
	actions: {
		fetchSwitchSite({ commit },data) {
			switchSiteAPI(data)
		},
		/* 设置记录当前选择站点信息 */
		fetchCurrentSiteInfo({ commit },data) {
			commit('setCurrentSiteInfo',data)
		},

		/* 获取搜索结果数据 */
		async fetchResultList({ commit },data) {
			const res = await getResultListAPI(data)
			commit('setResultList',res)
		},
		/* 添加站点-表单提交 */
		async fetchAddSite({ commit },data) {
			const res = await addSiteAPI(data)
			commit('setCurrentSite',res)
		},
		/* 确认添加 */
		async fetchConfirmSite({ commit },data) {
			const res = await confirmSiteAPI(data)
			return res
		},
	},
}

export default websiteConfigure